import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap, tap } from 'rxjs/operators';
import { WebsocketBrokerService } from '../services/websocket-broker.service';
import { NotificationActions } from './notification.actions';
import { NotificationState } from './notification.reducer';

@Injectable({
    providedIn: 'root' // No need to provide in AppModule, and now tree shakable
})
export class NotificationEffects {

    constructor(private actions$: Actions,
                private websocketBrokerService: WebsocketBrokerService) {
    }

    // TODO: Consider creating an operator to map start action with topic to action that updates state
    // TODO: Consider an createWebSocketSyncEffect
    startSyncTwoWayUnreadMessages$ = createEffect(() =>
        this.actions$
            .pipe(
                ofType(NotificationActions.startSyncUnreadTwoWayMessages),
                switchMap(() =>
                    this.websocketBrokerService.getRemoteObservable('twoway-unread/')
                        .pipe(
                            map(unreadMessages => {
                                const state: NotificationState = {
                                    unreadMessages
                                };

                                return NotificationActions.webSocketUnreadTwoWayMessagesPushed(state);
                            })
                        )
                )
            )
    );

    stopSyncTwoWayUnreadMessages$ = createEffect(() =>
        this.actions$
            .pipe(
                ofType(NotificationActions.stopSyncUnreadTwoWayMessages),
                tap(_ => this.websocketBrokerService.unsubscribe('twoway-unread/'))
            ),
        { dispatch: false }
    );

}
